import React from 'react';
import { Avatar, Box, Text } from '@chakra-ui/react';
import { getImageUrl } from 'utils';
import { CheckCircleIcon } from 'static/icons';
import styled from '@emotion/styled';
import { Rating } from './Rating';

const CheckCircleIconStyled = styled(CheckCircleIcon)`
  circle {
    fill: #70c274;
  }
  display: inline;
  margin-left: 8px;
  vertical-align: text-top;
`;

export const InfoMaster: React.FC<any> = ({
  id,
  name,
  position = 'Парикмахер',
  rating = 0,
  feedbackCount = 0,
  widgetId,
  onRatingClick,
  selected = false,
}) => {
  return (
    <Box display="flex" alignItems="center" overflow="hidden">
      <Avatar
        name={name}
        size="lg"
        src={getImageUrl(widgetId, 'CompanyEmployees', id)}
        loading="eager"
      />
      <Box ml={4}>
        <Text color="black" textStyle="h4" translate="no" whiteSpace="nowrap">
          <span>{name}</span>
          {selected && <CheckCircleIconStyled width={18} height={18} />}
        </Text>
        <Text color="grayText" textStyle="body2" mb={1}>
          {position}
        </Text>
        {rating ? (
          <Rating
            value={rating}
            feedbackCount={feedbackCount}
            onClick={onRatingClick}
          />
        ) : null}
      </Box>
    </Box>
  );
};
